import service from '@/utils/request'
import { getUploadTokenA, uploadA } from '@/server/api'
import { getToken } from '@/utils/auth'

function resolveUploadFilePath(data) {
  const ur = data && typeof data === 'object' ? data : {}
  const remoteKey =
    ur.key ||
    ur.Key ||
    ur.filepath ||
    ur.filePath ||
    ur.file_path ||
    ''
  return (
    (typeof ur.filepath === 'string' && ur.filepath) ||
    (typeof ur.filePath === 'string' && ur.filePath) ||
    (typeof ur.file_path === 'string' && ur.file_path) ||
    (typeof ur.url === 'string' && ur.url) ||
    (remoteKey && /^https?:\/\//i.test(String(remoteKey)) ? String(remoteKey) : '') ||
    (remoteKey ? String(remoteKey) : '')
  )
}

/**
 * 上传音频并返回服务端存储路径（写入 llmsettings 字段）
 * @param {File} file
 * @param {{ onLoading?: (destroy: () => void) => void, message?: Vue }} [options]
 */
export async function uploadAudioFile(file, options = {}) {
  const maxBytes = 10 * 1024 * 1024
  if (!file || file.size > maxBytes) {
    throw new Error('单文件不能超过 10MB')
  }

  let loadingDestroy
  if (options.message && options.message.loading) {
    loadingDestroy = options.message.loading({ content: '上传中…', duration: 0 })
  }
  options.onLoading?.(loadingDestroy)

  try {
    const tokenRes = await getUploadTokenA()
    if (!tokenRes || tokenRes.code !== 200) {
      throw new Error((tokenRes && tokenRes.message) || '获取上传凭证失败')
    }
    const payload = tokenRes.data || {}
    const uploadToken = payload.uploadToken || payload.upload_token
    if (!uploadToken) {
      throw new Error('上传凭证无效')
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('token', uploadToken)

    const uploadRes = await service.post(uploadA, formData, {
      headers: { Authorization: getToken() || '' },
      autoMsg: false,
    })

    if (!uploadRes || uploadRes.code !== 200) {
      throw new Error((uploadRes && uploadRes.message) || '上传失败')
    }

    const filePath = resolveUploadFilePath(uploadRes.data)
    if (!filePath) {
      throw new Error('上传成功但未返回文件路径')
    }

    return {
      filePath: String(filePath).trim(),
      fileName: file.name || '',
    }
  } finally {
    if (typeof loadingDestroy === 'function') loadingDestroy()
  }
}
